import { Button, Form } from "antd";
import React, { useEffect, useRef, useState } from "react";
import {
  aadharPattern,
  emailPattern,
  getLocalStorageItem,
  mobilePattern,
  panPattern,
} from "../../../Utils";
import { setselectedTab } from "../../../Store/B2bslice";
import { submitKyc } from "../../../ApiServices/Apifun";
import { useDispatch, useSelector } from "react-redux";
import VerifyModal from "../../../Common/VerifyModal";
import { Globalendpoints } from "../../../ApiServices/global";
import CommonInput from "../../../Common/CommonInput";
import { useNavigate } from "react-router-dom";

const KycForm = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const formref = useRef();
  const dispatch = useDispatch();
  const checkKyc = useSelector((state) => state.B2B.profileDetail);
  const [isOpen, setIsOpen] = useState(false);
  const [btnLoading,
     setBtnLoading] = useState(false);
  useEffect(() => {
    if (checkKyc.dmt_kyc === "1") {
      navigate("/dmt/remitters");
    }
  }, [checkKyc]);
  const handleSubmit = (val) => {
    setBtnLoading(true);
    const formdata = new FormData();
    formdata.append("latitude", getLocalStorageItem("latitude"));
    formdata.append("longitude", getLocalStorageItem("longitude"));
    Object.entries(val).map(([key, value]) =>
      formdata.append(key, value)
    );
    submitKyc(formdata)
      .then((res) => {
        if (res.status) {
          setIsOpen(true);
          // navigate("/dmt/verifyOtp");
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setBtnLoading(false));
  };
  useEffect(() => {
    dispatch(setselectedTab("4"));
  }, []);
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 place-items-start">
        <div className="prepaid w-full animate-slide-in bg-white rounded-3xl  shadow-normal  p-5">
          <p className="font-bold text-[15px] mb-2">Submit Kyc</p>
          <div className="selectionFields ">
            <Form
              name="basic"
              form={form}
              ref={formref}
              onFinishFailed={(err) => console.log(err)}
              onFinish={(val) => handleSubmit(val)}
            >
              <Form.Item
                name={`mobile`}
                label={"Mobile Number"}
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Enter Mobile Number!",
                  },
                  {
                    pattern: mobilePattern,
                    message: "Please enter a valid mobile number",
                  },
                  {
                    whitespace: true,
                    message: "Field cannot contain only blank spaces",
                  },
                ]}
              >
                <CommonInput
                  placeholder="Enter Your Mobile Number"
                  name="mobile"
                />
              </Form.Item>{" "}
              <Form.Item
                name={`aadhar_number`}
                label={"Aadhar Number"}
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Enter Aadhar Number!",
                  },
                  {
                    pattern: aadharPattern,
                    message: "Please enter a valid aadhar number",
                  },
                  {
                    whitespace: true,
                    message: "Field cannot contain only blank spaces",
                  },
                ]}
              >
                <CommonInput
                  placeholder="Enter Your Aadhar Number"
                  name="first_name"
                />
              </Form.Item>{" "}
              <Form.Item
                name={`email`}
                label={"Email"}
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Enter Email!",
                  },
                  {
                    pattern: emailPattern,
                    message: "Please enter a valid email address",
                  },
                  {
                    whitespace: true,
                    message: "Field cannot contain only blank spaces",
                  },
                ]}
              >
                <CommonInput placeholder="Enter Your Email" name="last_name" />
              </Form.Item>{" "}
              <Form.Item
                name={`pan`}
                label={"Pan Card Number"}
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Enter Pan!",
                  },
                  {
                    pattern: panPattern,
                    message: "Please enter a valid pan",
                  },
                  {
                    whitespace: true,
                    message: "Field cannot contain only blank spaces",
                  },
                ]}
              >
                <CommonInput
                  onInput={(e) => {
                    const value = e.target.value.toUpperCase();
                    e.target.value = value;
                  }}
                  placeholder="Enter Pan"
                  name="pin_code"
                />
              </Form.Item>{" "}
              <Form.Item
                initialValue={"N"}
                name={`consent`}
                labelCol={{ span: 24 }}
              >
                <div className="mt-2 flex justify-start items-center gap-x-3  checkbox">
                  <input
                    onInput={(e) => {
                      e.target.checked
                        ? form.setFieldsValue({ consent: "Y" })
                        : form.setFieldsValue({ consent: "N" });
                    }}
                    className="rounded-md"
                    type="checkbox"
                  />
                  <p className="text-textGray required">
                    I hereby allowing my aadhar for verification!
                  </p>
                </div>
              </Form.Item>{" "}
              <Form.Item>
                <Button
                  htmlType="submit"
                  loading={btnLoading}
                  className="bg-primary mt-2 w-full border-none rounded-md h-9 text-center text-white flex justify-center items-center font-bold text-md cursor-pointer"
                >
                  Submit
                </Button>
              </Form.Item>{" "}
            </Form>
          </div>
        </div>
      </div>
      {isOpen && (
        <VerifyModal
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          endpoint={Globalendpoints.verifyKycOtp}
          otherFields={{}}
        />
      )}
    </>
  );
};

export default KycForm;